import { DropdownProps } from "@fluentui/react-northstar";
import { openModal, useTranslate } from "front";
import { useContactListCache } from "../../../../hooks/useQuery/useContactListCache";
import { IDisplayMode } from "../../../../interfaces/IDisplayMode";
import { SyntheticEvent, useCallback, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { translations } from "../../../../translations";

export const useSettings = () => {
  const t = useTranslate(translations);
  const dispatch = useDispatch();
  const { queryContactList, updateContactListMutate } = useContactListCache();

  const getInitialDisplayMode = useMemo(() => {
    return queryContactList.data?.defaultDisplayMode ?? 0;
  }, [queryContactList.data?.defaultDisplayMode]);

  // State
  const [displayMode, setDisplayMode] = useState<0 | 1 | 2>(getInitialDisplayMode);

  const onClose = useCallback(() => {
    dispatch(openModal(undefined));
  }, []);

  const updateContact = () => {
    updateContactListMutate(
      { contactListId: queryContactList.data?.id, params: { ...queryContactList.data, defaultDisplayMode: displayMode } },
      {
        onSuccess: () => {
          dispatch(openModal(undefined));
        },
      }
    );
  };

  const handleDropDown = useCallback((_: SyntheticEvent | null, item: DropdownProps): void => {
    const value = item.value;
    if (!value) return;
    switch(value)
    {
      case t(IDisplayMode.CARD):
        setDisplayMode(0);
        return;
      case t(IDisplayMode.LIST):
        setDisplayMode(1);
        return;
      case t(IDisplayMode.GROUP):
        setDisplayMode(2);
        return;
    }
  }, []);

  const convertNumToString = () => {
    const map = {
      0: IDisplayMode.CARD,
      1: IDisplayMode.LIST,
      2: IDisplayMode.GROUP,
    };
    return t(map[displayMode]);
  };

  const dropDownItems = [t(IDisplayMode.CARD), t(IDisplayMode.LIST), t(IDisplayMode.GROUP)];

  return { onClose, updateContact, dropDownItems, handleDropDown, convertNumToString, displayMode };
};
